module.exports = __webpack_public_path__ + "img/parked_lorries.4f9d54c7.jpg";